import React, { useEffect, useMemo, useState } from "react"
import { Link, useI18next } from "gatsby-plugin-react-i18next"
import { useStaticQuery, graphql } from "gatsby"
import PropTypes from "prop-types"
import Container from "../Container"
import { Row, Col, Button, Space } from "antd"
import { CloseOutlined } from "@ant-design/icons"
import { HomeIcon, Phone } from "../Icon"
import Countdown from "react-countdown"

import "./TopNav.less"

const renderer = ({ days, hours, minutes, completed }) => {
  if (completed) {
    return <div />
  } else {
    return (
      <Space>
        <div>
          <span>{days}</span> hari
        </div>
        <span>:</span>
        <div>
          <span>{hours}</span> Jam
        </div>
        <span>:</span>
        <div>
          <span>{minutes}</span> Menit
        </div>
      </Space>
    )
  }
}

const TopNav = props => {
  const { languages, originalPath, t, ...rest } = useI18next()
  const { settings } = useStaticQuery(graphql`
    query CountdownQuery {
      settings {
        countdown {
          created_at
          end_date
          end_time
          is_display_countdown
          registration_url
          title
        }
      }
    }
  `)
  const [showCountDown, setShowCountDown] = useState(
    settings.countdown.is_display_countdown || 0
  )
  console.log(settings)
  useEffect(() => {
    if ((document.cookie || "").includes("hide-countdown")) {
      setShowCountDown(0)
    }
  }, [])

  const time = useMemo(() => {
    return new Date(
      `${settings.countdown.end_date}T${settings.countdown.end_time}:00`
    ).getTime()
  }, [settings.countdown.end_time, settings.countdown.end_time])
  return (
    <>
      {!!showCountDown && (
        <div
          className="top-banner"
          style={{
            backgroundImage: `url(${require("../../images/top-banner-bg.jpg")})`,
          }}
        >
          <Container>
            <Row justify="space-between">
              <Col xs={14} sm={12}>
                <Row align="middle" wrap>
                  <div className="top-banner__title">
                    {settings.countdown.title}
                  </div>
                  <div className="top-banner__countdown">
                    <Countdown date={time} renderer={renderer} />
                  </div>
                </Row>
              </Col>
              <Col xs={10} sm={12}>
                <Row align="middle" justify="end">
                  <Button
                    outline
                    type="ghost"
                    href={settings.countdown.registration_url}
                    style={{ color: "white", marginRight: 20 }}
                  >
                    {t("Lihat Detail")}
                  </Button>
                  <div
                    onClick={() => {
                      setShowCountDown(0)
                      document.cookie =
                        "cookieName=hide-countdown; max-age=86400; path=/;"
                    }}
                  >
                    <CloseOutlined
                      style={{ fontSize: 20, cursor: "pointer" }}
                    />
                  </div>
                </Row>
              </Col>
            </Row>
          </Container>
        </div>
      )}
      <div {...props}>
        <div className={"topnav " + props.theme}>
          <Container>
            <Row justify="space-between" align={{ xs: "top", md: "middle" }}>
              <Col span={{ xs: 24, md: 12 }}>
                <div className="topnav-inline">
                  <i className="topnav-icon topnav-icon--brown">
                    <HomeIcon />
                  </i>
                  <div className="topnav-content">{props.address}</div>
                </div>
              </Col>
              <Col span={{ xs: 24, md: 12 }}>
                <div className="topnav-container">
                  <div className="topnav-inline">
                    <i className="topnav-icon topnav-icon--blue">
                      <Phone />
                    </i>
                    <div className="topnav-content">
                      Call Center {props.phone}
                    </div>
                  </div>
                  <div className="topnav-inline hide-mobile">
                    <div className="lang">
                      {languages.map(function (lng, index) {
                        return (
                          <Button
                            type="link"
                            key={index}
                            style={{
                              color: "inherit",
                              fontWeight: lng === rest.language ? 700 : 400,
                            }}
                          >
                            <Link to={originalPath} language={lng}>
                              {(index ? "" : " | ") + lng}
                            </Link>
                          </Button>
                        )
                      })}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  )
}

TopNav.propTypes = {
  address: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
}

export default TopNav
